import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import ReactDOM from 'react-dom';
import 'react-loading-skeleton/dist/skeleton.css';
import './containers/main.css';
import './containers/main.scss';

import App from './App';

GoogleTagManager.initialize({ customerJourney: 'Signup' });

ReactDOM.render(<App />, document.getElementById('root'));
